import React from "react";

import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import File from "@peracto/peracto-editor-ui/dist/File";
import Select from "@peracto/peracto-editor-ui/dist/Select";
import Checkbox from "@peracto/peracto-editor-ui/dist/Checkbox";

const ImageAndTextForm = ({
    onChange,
    state: {
        url = "",
        mobileUrl = "",
        mobileImagePosition = "center",
        imageAndTextHeading = "",
        imageAndTextSubHeading = "",
        imageAndTextHeadingColour = "text-brand-black",
        imageAndTextSubHeadingColour = "text-brand-white",
        imageAndTextText = "",
        imageAndTextButtonText = "",
        imageAndTextButtonLink = "",
        imageAndTextButtonColour = "primary",
        showCallbirdButton = false,
    },
}) => {
    const buttonColourOptions = [
        { label: "Blue", value: "primary" },
        { label: "Orange", value: "tertiary" },
        { label: "Green", value: "sextary" },
        { label: "Pink", value: "quaternary" },
        { label: "Yellow", value: "quinary" },
    ];

    const imageAndTextHeadingColourOptions = [
        { label: "Black", value: "text-brand-black" },
        { label: "White", value: "text-brand-white" },
        { label: "Blue", value: "text-brand-primary" },
        { label: "Orange", value: "text-brand-secondary" },
        { label: "Green", value: "text-brand-tertiary" },
        { label: "Pink", value: "text-brand-quaternary" },
        { label: "Yellow", value: "text-brand-quinary" },
    ];

    const mobileImagePositionOptions = [
        { label: "Left", value: "left" },
        { label: "Centre", value: "center" },
        { label: "Right", value: "right" },
    ];

    return (
        <>
            <File
                label="Image URL"
                value={url}
                onChange={(value) => onChange({ url: value })}
                isInline={false}
            />

            <File
                label="Mobile Image URL"
                value={mobileUrl}
                onChange={(value) => onChange({ mobileUrl: value })}
                isInline={false}
            />

            <Select
                label="Mobile Image Position"
                value={mobileImagePosition || "center"}
                onChange={(e) => onChange({ mobileImagePosition: e.value })}
                options={mobileImagePositionOptions}
            />

            <TextInput
                label="Heading"
                value={imageAndTextHeading}
                onChange={(e) =>
                    onChange({ imageAndTextHeading: e.target.value })
                }
            />

            <Select
                label="Heading Colour"
                value={imageAndTextHeadingColour}
                onChange={(e) =>
                    onChange({ imageAndTextHeadingColour: e.value })
                }
                options={imageAndTextHeadingColourOptions}
            />

            <TextInput
                label="Sub Heading"
                value={imageAndTextSubHeading}
                onChange={(e) =>
                    onChange({ imageAndTextSubHeading: e.target.value })
                }
            />

            <Select
                label="Sub Heading Colour"
                value={imageAndTextSubHeadingColour}
                onChange={(e) =>
                    onChange({ imageAndTextSubHeadingColour: e.value })
                }
                options={imageAndTextHeadingColourOptions}
            />

            <TextInput
                label="Text"
                value={imageAndTextText}
                onChange={(e) => onChange({ imageAndTextText: e.target.value })}
            />

            <TextInput
                label="Button Text"
                value={imageAndTextButtonText}
                onChange={(e) =>
                    onChange({ imageAndTextButtonText: e.target.value })
                }
            />

            <TextInput
                label="Button Link"
                value={imageAndTextButtonLink}
                onChange={(e) =>
                    onChange({ imageAndTextButtonLink: e.target.value })
                }
            />

            <Select
                label="Button Colour"
                value={imageAndTextButtonColour}
                onChange={(e) =>
                    onChange({ imageAndTextButtonColour: e.value })
                }
                options={buttonColourOptions}
            />

            <Checkbox
                label="Show Callbird Button"
                checked={showCallbirdButton}
                onChange={(e) =>
                    onChange({ showCallbirdButton: e.target.checked })
                }
            />
        </>
    );
};

export default ImageAndTextForm;
